import * as React from "react";
import { resolveDiagramSvgHeight } from "../shared/diagramSvgDimensions";


import { MethylationTranssulphurationDiagramContent } from "./MethylationTranssulphurationDiagram";
import { MethylationTranssulphurationKeyContent } from "./MethylationTranssulphurationKey";

const SvgMethylationTranssulphurationDiagramKey = ({
  geneColors = {},
  expectedSnps = {},
  showKey = true,
  keyControlsId = "diagram-key",
  onGeneClick,
  width: widthProp,
  height: heightProp,
  ...props
}) => {
  const diagramOnly = !showKey;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      {...props}
      width={widthProp ?? 1024}
      height={resolveDiagramSvgHeight(heightProp, diagramOnly, 1210, 1426)}
      viewBox={diagramOnly ? "0 142 1024 1210" : "0 0 1024 1426"}
    >
      <g id="methylation-transsulphuration-diagram+key" clipPath="url(#clip0_18291_211487)">
        <rect width={1024} height={diagramOnly ? 1210 : 1426} fill="white" />
        {showKey && (
          <g id={keyControlsId}>
            <MethylationTranssulphurationKeyContent />
          </g>
        )}
        <g transform={showKey ? `translate(0 74)` : undefined}>
          <MethylationTranssulphurationDiagramContent
            geneColors={geneColors}
            expectedSnps={expectedSnps}
            onGeneClick={onGeneClick}
          />
        </g>
      </g>
      <defs>
        <clipPath id="clip0_18291_211487">
          <rect width={1024} height={1426} fill="white" />
        </clipPath>
        <clipPath id="clip1_18291_211487">
          <rect width={1024} height={1210} fill="white" transform="translate(0 142)" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default SvgMethylationTranssulphurationDiagramKey;
